import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-successfully-subscribed',
  templateUrl: './successfully-subscribed.component.html',
  styleUrls: ['./successfully-subscribed.component.scss']
})
export class SuccessfullySubscribedComponent implements OnInit {
/* --------------------------------- FIELDS -------------------------------- */
  /* ------------------------------- CONSTRUCTOR ------------------------------ */
  constructor(
    private _dialogRef: MatDialogRef<SuccessfullySubscribedComponent>,
    @Inject(MAT_DIALOG_DATA) public data: null,
  ) { }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit() {
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */
  dialogClose() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
  /* --------------------------------- GETTERS --------------------------------- */
}
